import TopSection from "../../../LT/TopSection";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import ButtonComponent from "../../../../components/common/button/Button";
import InviteUserModal from "../InviteUserModal";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { postInviteSupplier } from "../../../../redux/actions/PostInviteSupplierListSlice";
import { getAdminSupplierUserListEndpoint, postInviteSupplierEndpoint } from "../../../../common/endpoints";
import { getAdminSupplierUserList } from "../../../../redux/actions/GetAdminSupplierUserListSlice";
import { Loader } from "../../../../components/common/Loader";
import { deleteAdminSupplierRow } from "../../../../redux/actions/DeleteAdminSupplierSlice";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { putEditInviteSupplier } from "../../../../redux/actions/PUTEditInviteUserSlice";
import { DeleteUserModal } from "../DeleteUserModal";

const AdminManageUsers = () => {
    const gridRef = useRef();
    const dispatch = useDispatch();
    const AdminSupplierStateSelector = useSelector((state) => state.GetAdminSupplierUserListSlice);
    const [gridApi, setGridApi] = useState();
    const [rowData, setRowData] = useState([]);
    const [openModalData, setOpenModalData] = useState(false);
    const [openDeleteConfirmationModalData, setOpenDeleteConfirmationModalData] = useState(false);
    const [selectedDeleteRowItem, setSelectedDeleteRowItem] = useState({});
    const [modalDataForSupplierChip, setModalDataForSupplierChip] = useState(false);
    const [openInviteUserModal, setOpenInviteUserModal] = useState(false);
    const [editModeData, setEditModeData] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
    const loggedInUserEmail = localStorage.getItem("userEmail");
    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params.api;
    }
    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.userEmail}`
        },

    }
    const onClickDeleteLineItem = async (item) => {
        setOpenDeleteConfirmationModalData(true);
        setSelectedDeleteRowItem(item)
    }
    const onClickEditExistingRecords = (item) => {
        setIsEditMode(true)
        setOpenInviteUserModal(true);
        setEditModeData(item.data)
    }
    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: "agMultiColumnFilter"
        }),
        []
    );
    const getSupplierUserData = async () => {
        try {
            const responseGetSupplierList = await dispatch(getAdminSupplierUserList({
                dynamicEndpoint: getAdminSupplierUserListEndpoint,
            }));
            if (responseGetSupplierList?.meta?.requestStatus === 'fulfilled') {
                if (responseGetSupplierList?.payload?.length > 0) {
                    setRowData(responseGetSupplierList.payload);
                } else {
                    setRowData([]);
                }
            }
            else {
                toast.error(responseGetSupplierList?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }

    }
    useEffect(() => {
        getSupplierUserData();
    }, [])
    const onClickOpenVendorSupplierChipModal = (data) => {
        setOpenModalData(true);
        setModalDataForSupplierChip(data);
    }
    const onClickCloseVendorSupplierChipModal = () => {
        setOpenModalData(false);
        setModalDataForSupplierChip([]);
    }

    const columns = [
        {
            field: "userEmail",
            headerName: "User Email",
            flex: 1
        },
        {
            field: "role",
            headerName: "Role",
            flex: 1
        },
        {
            field: "vendor",
            headerName: "Supplier",
            flex: 1,
            // wrapText: true,
            autoHeight: true,
            valueGetter: (params) => {
                return params.data?.supplierMapping
                    ?.map(item => `${item.parentId} | ${item.parentName}`)
                    .join(", ");
            },
            cellRenderer: (response) => {
                return <div onClick={() => onClickOpenVendorSupplierChipModal(response.data)} style={{ cursor: 'pointer', textOverflow: "ellipsis", maxWidth: 250, whiteSpace: "nowrap", overflow: "hidden", }}>
                    {response && response?.data?.supplierMapping?.map((item) =>
                        <Chip
                            key={item.parentId}
                            label={`${item.parentId} | ${item.parentName}`}
                            sx={{ m: 0.5 }}
                        />
                    )}
                </div>
            }
        },
        {
            field: "actions",
            headerName: "Actions",
            cellRenderer: (response) => (
                <div className="btn-wrapper" style={{ marginTop: 6, gap: 30 }} >
                    <EditIcon title="edit" onClick={() => onClickEditExistingRecords(response)} style={{ cursor: 'pointer', marginRight: 20, color: '#000' }} />
                    <DeleteIcon onClick={() => onClickDeleteLineItem(response)} style={{ cursor: 'pointer', marginRight: 20, color: '#000' }} />
                </div>
            ),
            pinned: 'right',
            lockPinned: true,
            lockPosition: true
        }]
    const onClickInviteUsers = () => {
        setOpenInviteUserModal(true)
    }
    const handleCloseInviteUserModal = () => {
        setOpenInviteUserModal(false);
        setIsEditMode(false);
        setEditModeData([])
    }
    const handleCloseDeleteModal = () => {
        setOpenDeleteConfirmationModalData(false);
        setSelectedDeleteRowItem({})
    }
    const handleDeleteConfirmation = async () => {
        const item = selectedDeleteRowItem;

        try {
            const responseDeleteSupplier = await dispatch(deleteAdminSupplierRow({
                dynamicEndpoint: `${getAdminSupplierUserListEndpoint}/${item.data.userEmail}`,
            }));
            if (responseDeleteSupplier?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseDeleteSupplier?.payload, {
                    autoClose: 2000,
                });
                setOpenDeleteConfirmationModalData(false);
                getSupplierUserData();
            }
            else {
                toast.error(responseDeleteSupplier?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }

    }
    function generateInviteList(selectedData) {
        const mapRole = (role) => {
            if (role === "Supplier Planner") return "SupplierPlanner";
            if (role === "Supplier Admin - Global") return "SupplierAdmin";
            if (role === "Supplier Admin - Local") return "SupplierAdmin";
            return role.replace(/\s+/g, "");
        };
        return selectedData?.map((row, index) => {
            const originalRole = row.role;
            const role = mapRole(originalRole);
            let supplierList = [];
            if (originalRole === "Supplier Admin - Global") {
                const parents = row.supplierId.map(s => ({ id: s.parentId, name: s.parentName }));
                supplierList = parents.map(parent => ({
                    supplierId: parent.id,
                    supplierName: parent.name,
                    parentName: parent.name,
                    supplierType: "Parent",
                    plants: []
                }));
            }
            else if (originalRole === "Supplier Admin - Local" || originalRole === "Supplier Planner") {
                const mergedRows = selectedData?.map(item => ({
                    ...item,
                    childSupplierId: item?.childSupplierId?.map(child => ({
                        ...child,
                        parentName: child.parentName,
                        selectedPlants: item?.selectedPlants
                    }))
                }));
                supplierList = mergedRows[index]?.childSupplierId?.map(sp => ({
                    supplierId: sp.supplierId,
                    supplierName: sp.supplierName,
                    parentName: sp.parentName,
                    supplierType: "Child",
                    plants: sp.selectedPlants.map(p => p.value)
                }));
            }
            return {
                inviteeEmail: row.email?.trim(),
                role: role,
                supplierList
            };
        });
    }
    const handleUpdateEditDetailsModal = async (rows) => {
        const editListData = generateInviteList(rows);

        const editListRequestBody = {
            "userEmail": loggedInUserEmail,
            "supplierEmail": editListData[0].inviteeEmail,
            "role": editListData[0].role,
            "supplierList": editListData[0].supplierList
        }
        try {
            const responseInviteSupplier = await dispatch(putEditInviteSupplier({
                dynamicEndpoint: getAdminSupplierUserListEndpoint,
                data: editListRequestBody,
            }));

            if (responseInviteSupplier?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseInviteSupplier?.payload, {
                    autoClose: 2000,
                });
                handleCloseInviteUserModal();
                getSupplierUserData();
            }
            else {
                toast.error(responseInviteSupplier?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const handleSubmitInviteUserModal = async (rows) => {
        const inviteListData = generateInviteList(rows);
        const inviteListRequestBody = {
            "userEmail": loggedInUserEmail,
            "inviteList": inviteListData
        }
        try {
            const responseInviteSupplier = await dispatch(postInviteSupplier({
                dynamicEndpoint: postInviteSupplierEndpoint,
                data: inviteListRequestBody,
            }));

            if (responseInviteSupplier?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseInviteSupplier?.payload, {
                    autoClose: 2000,
                });
                handleCloseInviteUserModal();
                getSupplierUserData();
            }
            else {
                toast.error(responseInviteSupplier?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Admin" },
                ]}
                tabTitle="Manage Users"
            />
            <div>
                {AdminSupplierStateSelector?.loading ?
                    <Loader />
                    :
                    <>
                        <div style={{ display: 'flex', justifyContent: 'end', marginRight: 20, marginTop: -50 }}>
                            <ButtonComponent
                                type="secondary"
                                maxWidth="130px"
                                label="+ Invite Users"
                                height="40px"
                                onClick={onClickInviteUsers}
                            />
                        </div>
                        <div style={{ margin: '10px 0px' }}>
                            <div className="ag-theme-quartz" style={{ height: 400, width: '100%' }}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowData={rowData}
                                    columnDefs={columns}
                                    onGridReady={onGridReady}
                                    gridOptions={gridOptions}
                                    defaultColDef={defaultColDef}
                                    pagination={pagination}
                                    paginationPageSize={paginationPageSize}
                                    paginationPageSizeSelector={paginationPageSizeSelector}
                                />
                            </div>
                        </div>
                        <InviteUserModal openInviteUserModal={openInviteUserModal} handleCloseInviteUserModal={handleCloseInviteUserModal} handleSubmitInviteUserModal={handleSubmitInviteUserModal} isEditMode={isEditMode} editModeData={editModeData} handleUpdateEditDetailsModal={handleUpdateEditDetailsModal} />
                        <DeleteUserModal openDeleteConfirmationModalData={openDeleteConfirmationModalData} handleCloseDeleteModal={handleCloseDeleteModal} handleDeleteConfirmation={handleDeleteConfirmation} />
                        <Dialog open={openModalData} onClose={onClickCloseVendorSupplierChipModal} fullWidth>
                            <DialogTitle>Selected Options</DialogTitle>
                            <DialogContent sx={{ maxHeight: 420, overflowY: "auto" }}>
                                {modalDataForSupplierChip?.supplierMapping?.length === 0 ? (
                                    <Box sx={{ p: 2 }}>No items selected</Box>
                                ) : (
                                    modalDataForSupplierChip?.supplierMapping?.map(grp => (
                                        <Box key={grp.parentId} sx={{ mb: 2, borderBottom: '1px solid #bcbcbc' }}>
                                            <Box sx={{ fontWeight: 700, mb: 1 }}>{`${grp.parentId} | ${grp.parentName}`}</Box>
                                            {grp?.childSuppliers?.map(item => (
                                                <>
                                                    <Box sx={{ color: "#666", mb: 1 }}>{`${item.supplierId} | ${item.supplierName}`}</Box>
                                                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                                        {item?.plants?.map(p => (
                                                            <Chip
                                                                key={p.plant}
                                                                label={`${p.plant} | ${p.plantName}`}
                                                                sx={{ m: 0.5 }}
                                                            />
                                                        ))}
                                                    </Box>
                                                </>
                                            ))}
                                        </Box>
                                    ))
                                )}
                            </DialogContent>
                            <DialogActions>
                                <ButtonComponent
                                    label="Close"
                                    type="primary"
                                    maxWidth="80px"
                                    onClick={onClickCloseVendorSupplierChipModal}
                                />
                            </DialogActions>
                        </Dialog>
                    </>}
            </div>
        </div>
    )
}

export default AdminManageUsers;
